"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _ButtonDropdown = require("./ButtonDropdown");
Object.keys(_ButtonDropdown).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ButtonDropdown[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ButtonDropdown[key];
    }
  });
});
var _SimpleButtonDropdown = require("./SimpleButtonDropdown");
Object.keys(_SimpleButtonDropdown).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SimpleButtonDropdown[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _SimpleButtonDropdown[key];
    }
  });
});